import { render } from "./Extras.vue?vue&type=template&id=67c997b9"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__